"use client";

import type { AnalyticsEvent } from "./analytics-events";

/**
 * Cliente-side analytics wrapper para Google Analytics 4 (gtag.js).
 *
 * Mismo shape que el wrapper de ue-web — todos los frontends usan la
 * misma firma para que cualquier dev nuevo aprenda una API. Diferencia
 * de catálogo: landing trackea funnel top (hero, register, producer
 * lead-form) y NO trackea e-commerce porque las compras viven en web
 * cliente.
 *
 * SSR-safe: si window no existe, no-op. Si gtag aún no cargó
 * (Provider está pendiente o adblocker lo mata), también no-op
 * silencioso para no tirar la app.
 */
export function track(
  event: AnalyticsEvent,
  properties?: Record<string, unknown>,
): void {
  if (typeof window === "undefined") return;
  const gtag = (window as unknown as { gtag?: GtagFn }).gtag;
  if (typeof gtag !== "function") return;
  gtag("event", event, properties ?? {});
}

/**
 * Asocia el `user.id` a la sesión analítica. En landing aplica
 * principalmente después de un signup exitoso para stitchear la
 * conversion del visitante anónimo con el usuario creado.
 */
export function identify(userId: string): void {
  if (typeof window === "undefined") return;
  const gtag = (window as unknown as { gtag?: GtagFn }).gtag;
  if (typeof gtag !== "function") return;
  gtag("set", "user_properties", { user_id: userId });
  const id = process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID;
  if (id) gtag("config", id, { user_id: userId });
}

type GtagFn = (...args: unknown[]) => void;
